export const answersToPercentage = (
  currentQuestionAnswers: Record<string, number>,
  totalPlayers: number,
): Record<string, number> => {
  const totalAnswers = Object.values(currentQuestionAnswers).reduce((sum, count) => sum + count, 0);

  // If there are no answers, return an empty record
  if (totalAnswers === 0) {
    return {};
  }

  const percentageRecord: Record<string, number> = {};

  for (const [answerOption, count] of Object.entries(currentQuestionAnswers)) {
    const percentage = (count / totalPlayers) * 100;
    percentageRecord[answerOption] = Math.round(percentage);
  }

  return percentageRecord;
};
